import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "imageUpload" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-image" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddMediaRander = _resolveComponent("AddMediaRander")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_p = _resolveComponent("n-p")!
  const _component_n_upload_dragger = _resolveComponent("n-upload-dragger")!
  const _component_n_upload = _resolveComponent("n-upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(_ctx.GetPath()) + " ", 1),
    _createVNode(_component_AddMediaRander, {
      value: _ctx.GetPath(),
      onDeleteImage: _ctx.DeleteImage,
      postMediaTypeId: _ctx.postMediaTypeId
    }, null, 8, ["value", "onDeleteImage", "postMediaTypeId"]),
    _createVNode(_component_n_upload, {
      "directory-dnd": "",
      "custom-request": _ctx.customRequest,
      multiple: "",
      accept: _ctx.accept
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_upload_dragger, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_n_text, { style: {"font-size":"16px"} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.mediaTitle), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_n_p, {
                depth: "3",
                style: {"margin":"8px 0 0 0"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" يمنع تحميل المعلومات الحساسة. على سبيل المثال ، رقم التعريف الشخصي لبطاقتك المصرفية أو تاريخ انتهاء صلاحية بطاقتك الائتمانية. ")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["custom-request", "accept"])
  ], 64))
}